import { useEffect, useState } from "react";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import FormItem from "./FormItem";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Grid } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import MultiSelectDropdown from "../../shared/MultiSelectDropdown";
import api from "../../api"
import { updateAgencyAbout, updateAgencyShowrooms, updateVisionGoals } from "../../redux/reducers/userReducer"
import { connect, useDispatch } from "react-redux";

function getFullLanguage(key) {
  let languages = {
    "GB" : "English",
    "ES" : "Spanish",
    "FR" : "French",
    "DE" : "German",
  };
  if(Object.keys(languages).indexOf(key)<0) return null;
  return languages[key];
}

const AboutSection = ({ user }) => {
  const dispatch = useDispatch();
  const initialValues = {
    agencyName            : user.company.name,
    languages             : user.company.about ? user.company.about.languages : "",
    availability          : user.company.about ? user.company.about.availability : "",
    showroomAddress       : user.company.about ? user.company.showrooms.toString() : "",
    aboutAgency           : user.company.about ? user.company.about.about_agency : "",
    industryExpertise     : user.company.about ? user.company.about.industry_expertise : "",
    industryExperience    : user.company.about ? user.company.about.industry_experience : "",
    numberOfAgents        : user.company.about ? user.company.about.number_of_agents : "",
    brandPartnershipGoals : user.company.about ? user.company.vg_brand_partnership : "",
    salesGoals            : user.company.about ? user.company.vg_sales : "",
    strengths             : user.company.about ? user.company.vg_strengths : "",
  };

  const languages = [
    { value : "GB", label: "English" },
    { value : "ES", label: "Spanish" },
    { value : "FR", label: "French" },
    { value : "DE", label: "German" },
  ];

  const [inputValues, setInputValues] = useState(initialValues);
  const [ selectedLanguages, setSelectedLanguages ] = useState(user?.company?.about?.languages?.map((l) => { return { label: getFullLanguage(l), value: l } }));
  const [snackbarState, setSnackbarState] = useState({ open: false });
  const { open } = snackbarState;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    const agencySelectedLanguage = [];
    selectedLanguages.forEach( language => {
      agencySelectedLanguage.push( language.value );
    } );

    api.updateAboutDetails(
      user.company.id,
      {
        languages               : agencySelectedLanguage,
        availability            : inputValues.availability,
        showroom_address        : inputValues.showroomAddress,
        about_agency            : inputValues.aboutAgency,
        industry_expertise      : inputValues.industryExpertise,
        industry_experience     : parseInt( inputValues.industryExperience ),
        number_of_agents        : parseInt( inputValues.numberOfAgents ),
        brand_partnership_goals : inputValues.brandPartnershipGoals,
        sales_goals             : inputValues.salesGoals,
        strengths               : inputValues.strengths,
      },
      ( res ) => {
        if ( res.status === 200 ) {
          dispatch( updateAgencyAbout( res.data.about ) );
          dispatch( updateAgencyShowrooms( res.data.showrooms ) );
          dispatch( 
            updateVisionGoals({
              vg_brand_partnership: res.data.vg_brand_partnership,
              vg_sales            : res.data.vg_sales,
              vg_strengths        : res.data.vg_strengths
            })
          );
          openSuccessSnackbar();
        }
      }
    );
  };

  const openSuccessSnackbar = () => {
    setSnackbarState({ open: true });
  };

  const handleCloseSnackbar = () => {
    setSnackbarState({ open: false });
  };

  return (
    <>
      <div style={{ marginTop: 26 }} className="w-14"></div>
      <div className="space-y-8">
        <FormItem label="Agency Name">
          <Input
            placeholder="Agency Name"
            name="agencyName"
            value={inputValues.agencyName}
            onChange={handleInputChange}
          />
        </FormItem>
        {/* Requires development of new features */}
        <FormItem label="Languages">
          <MultiSelectDropdown 
            options={languages} 
            value={selectedLanguages} 
            onChange={setSelectedLanguages} 
            />
        </FormItem>
        <FormItem label="Availability">
          <Input
            type="date"
            name="availability"
            value={inputValues.availability}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="Showroom Address(es) (Optional)">
          <Textarea
            placeholder="Showroom Address(es)"
            name="showroomAddress"
            rows={3}
            value={inputValues.showroomAddress}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="About the Agency">
          <Textarea
            placeholder="About the Agency"
            name="aboutAgency"
            rows={4}
            value={inputValues.aboutAgency}
            onChange={handleInputChange}
          />
        </FormItem>
        {/* Requires development of new features */}
        <FormItem label="Industry Expertise">
          <Input
            placeholder="Tags"
            name="industryExpertise"
            value={inputValues.industryExpertise}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="Years of Experience in the Industry">
          <Input
            type="number"
            name="industryExperience"
            value={inputValues.industryExperience}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="Number of Agents Working at Your Agency">
          <Input
            type="number"
            name="numberOfAgents"
            value={inputValues.numberOfAgents}
            onChange={handleInputChange}
          />
        </FormItem>
        <div>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Vision and Goals
          </span>
        </div>
        <FormItem label="What Are You Looking for in a Brand Partnership?">
          <Textarea
            placeholder="Your goals for brand partnerships"
            name="brandPartnershipGoals"
            rows={4}
            value={inputValues.brandPartnershipGoals}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="Your Long-Term Goals in Sales">
          <Textarea
            placeholder="Your long-term sales goals"
            name="salesGoals"
            rows={4}
            value={inputValues.salesGoals}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem label="Your Strengths">
          <Textarea
            placeholder="Your strengths (e.g., customer acquisition, relationship management)"
            name="strengths"
            rows={4}
            value={inputValues.strengths}
            onChange={handleInputChange}
          />
        </FormItem>

        <Grid container direction={"row"} className={"fullWidth"}>
          <div className={"flex-1"}></div>
          <ButtonPrimary onClick={handleSaveChanges}>Save Changes</ButtonPrimary>
        </Grid>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        message="About Section Saved"
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          About Section Saved Successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = ( state ) => ({
  user    : state.user.user
})

export default connect( mapStateToProps, { updateAgencyAbout, updateAgencyShowrooms, updateVisionGoals } )( AboutSection );
